/**
 * ClipReview — final review pane shown after recording clips.
 * Pure UI; receives state + handlers from the parent CreatorRecorder.
 * Extracted in iter-41.
 */
import React from "react";
import { Plus, Trash2, Check, Film } from "lucide-react";


export default function ClipReview({
  clips, totalMs, storeReady,
  onAddClip, onRedo, onPost, fmt,
}) {
  return (
    <div className="p-3 bg-[#261534] flex flex-wrap items-center justify-center gap-2">
      <div className="text-xs text-[#A1A1AA] mr-2 hidden sm:inline">
        <Film size={12} className="inline mr-1"/>
        {clips.length} clip{clips.length !== 1 ? "s" : ""} · {fmt(totalMs)}
      </div>
      <button onClick={onAddClip} data-testid="rec-add-clip-btn" className="btn-secondary text-xs">
        <Plus size={12} className="inline mr-1"/>Add clip
      </button>
      <button onClick={onRedo} data-testid="rec-redo-btn" className="btn-secondary text-xs">
        <Trash2 size={12} className="inline mr-1"/>Redo
      </button>
      <button onClick={onPost} disabled={!storeReady} data-testid="rec-post-btn" className="btn-primary text-xs">
        <Check size={12} className="inline mr-1"/>Post video
      </button>
    </div>
  );
}
